/**
 * GameEngine — CLIENT STUB (Phase 6)
 *
 * The real tick loop now runs server-side (server/game/GameEngine.js).
 * This file is retained as an empty stub so that any remaining imports of
 * GameEngine from panels or utilities continue to resolve without errors.
 *
 * All simulation methods are no-ops. Speed controls have been removed from
 * the HUD (decision 5 — no pause exists in the shared world). The "live"
 * indicator in HUD replaces the speed buttons.
 *
 * Do NOT delete this file. Do NOT add logic here. If you need something that
 * was previously driven by the tick loop, listen to EventBus deltas that the
 * server pushes via WebSocket instead.
 */

export class GameEngine {
  constructor() {
    // No-op — no interval, no state
  }

  /** No-op — server controls time */
  start()  {}
  /** No-op */
  pause()  {}
  /** No-op */
  stop()   {}
  /** No-op — speed is server-configured */
  setSpeed() {}

  /** Returns 1 (irrelevant — server controls speed) */
  static getSavedSpeed() { return 1; }
}
